import { render, staticRenderFns } from "./MySpaces.vue?vue&type=template&id=7cb05db8"
import script from "./MySpaces.vue?vue&type=script&lang=js"
export * from "./MySpaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports